import {
    B__Publications,
    B__PublicationsEntry,
    RangeSlider
} from './B__Publications';

export const B__PublicationsModule = {
    B__Publications,
    B__PublicationsEntry,
    RangeSlider
};
